import { render, staticRenderFns } from "./DeviceNotifyStat_del.vue?vue&type=template&id=2626a1ab&scoped=true&"
import script from "./DeviceNotifyStat_del.vue?vue&type=script&lang=js&"
export * from "./DeviceNotifyStat_del.vue?vue&type=script&lang=js&"
import style0 from "./DeviceNotifyStat_del.vue?vue&type=style&index=0&id=2626a1ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2626a1ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VApp,VAppBar,VBtn,VCard,VContainer,VContent,VDivider,VIcon,VSpacer,VToolbarTitle})
